/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
  // Remove empty P tags created by WP inside of Accordion and Orbit
  jQuery(".accordion p:empty, .orbit p:empty").remove();

  document.querySelector('.arrow-icon').addEventListener('click', function() {
  jQuery('html,body').animate({
      scrollTop: jQuery("#releases").offset().top - 75
    });
  });

  // Adds Flex Video to YouTube and Vimeo Embeds
  jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(
    function() {
      if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
        jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
      } else {
        jQuery(this).wrap("<div class='responsive-embed'/>");
      }
    }
  );




  let nextSVG =
    "<label class='next-slide-button'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'><path d='M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z'/></svg></label>";

  let prevSVG =
    "<label class='prev-slide-button'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'><path d='M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z'/></svg></label>";

  jQuery(".releases-slider").slick({
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 3,
    nextArrow: nextSVG,
    prevArrow: prevSVG,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          infinite: true
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true
        }
      }
    ]
  });

  jQuery(".blog-post-slider").slick({
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: nextSVG,
    prevArrow: prevSVG,
    centerPadding: "100px",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          dots: true,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          dots: true
        }
      },
      {
        breakpoint: 300,
        settings: {
          slidesToShow: 1,
          dots: true
        }
      }
    ]
  });

  // var feed = new Instafeed({
  //   get: "user",
  //   userId: "8526796343",
  //   clientId: "5ce72c2355e74df38900379a75b3f174",
  //   accessToken: "420880545.5ce72c2.2f5a15c93ecf4a6b8a422ce39b87ec07"
  // });
  // feed.run();
});
